import { createLocalOrUTC } from './from-anything';

export function createLocal(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/moment/src/lib/create/local.js
// module id = jsFG
// module chunks = 0